/**
 * @template T
 * @param {T[]} array
 * @param {number} columnCount
 * @returns {T[][]}
 */
export function makeMatrix(array, columnCount = 1) {
  const ans = Array.from({
    length: columnCount
  }, () => []);
  let idx = 0;
  array.forEach(element => {
    ans[idx].push(element);
    idx += 1;
    if (idx >= columnCount) idx = 0;
  });
  return ans;
}

/**
 * 使用 findIndex 寻找元素，如果存在就删除他
 *
 * @template T
 * @param {T[]} array
 * @param {(item: T, index: number, arr: T[]) => boolean} predict
 */
export function findAndRemove(array, predict) {
  if (!Array.isArray(array)) return;
  const index = array.findIndex(predict);
  if (index >= 0) array.splice(index, 1);
}

/**
 * 数组里插入一个元素，会放到符合 predict 条件的第一个元素之前。如果所有元素都不符合，就会放到数组末尾
 *
 * @template T
 * @param {T[]} array
 * @param {T} item
 * @param {(item: T, index: number, arr: T[]) => boolean} predict
 */
export function insertBefore(array, item, predict) {
  if (!Array.isArray(array)) return;
  const index = array.findIndex(predict);
  if (index >= 0) array.splice(index, 0, item);else array.push(item);
}

/**
 * @template T
 * @typedef {Iterable<T> | T | null | undefined} OneOrMany
 */

/**
 * - 如果传入是 null 或者 undefined，会返回空数组。
 * - 如果传入一个非数组的对象，会返回一个长度为 1 的新 Array。
 * - 如果传入就是一个数组，则给出数组的浅层copy。
 * - 如果传入一个迭代器，就等同使用 Array.from 处理
 *
 * @template T
 * @param {OneOrMany<T>} x
 * @returns {T[]}
 */
export function arrayify(x) {
  // eslint-disable-next-line eqeqeq
  if (x == null) return [];
  if (typeof x === 'object' && Symbol.iterator in x) return Array.from(x);
  return [x];
}

/**
 * 在保证 x,y 都是数组的情况下，做浅 isEqual 比较。默认使用 `===` 比较
 *
 * 这个函数假设你已经保证 x,y 是数组了
 *
 * @template T
 * @param {T[]} x
 * @param {T[]} y
 * @param {(a: T, b: T) => boolean} [isEqual]
 * @returns {boolean}
 */
export function isArrayShallowEqual(x, y, isEqual) {
  if (x.length !== y.length) return false;
  if (typeof isEqual !== 'function') return x.every((v, i) => v === y[i]);
  return x.every((v, i) => isEqual(v, y[i]));
}

/**
 * @param {string[]} items 例如 ['+aaa', '+bbb', '-aaa']
 * @return {Set<string>}
 */
export function computeFilteredResult(items) {
  const answer = new Set();
  Array.isArray(items) && items.forEach(s => {
    answer[s[0] === '+' ? 'add' : 'delete'](s.slice(1));
  });
  return answer;
}
//# sourceMappingURL=array.js.map
